import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Create from './pages/Create';
import Created from './pages/Created';
import Choose from './pages/Choose';
import Success from './pages/Success';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import WidgetFrame from './pages/WidgetFrame';
import Demo from './pages/Demo';
import PartnerDashboard from './pages/PartnerDashboard';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import Generator from './pages/Generator';

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/create" element={<Create />} />
            <Route path="/created" element={<Created />} />
            <Route path="/gift/:giftId" element={<Choose />} />
            <Route path="/success" element={<Success />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/widget" element={<WidgetFrame />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you/:giftId" element={<ThankYou />} />
            <Route path="/generator" element={<Generator />} />
        </Routes>
    );
}
